import * as React from 'react';
import {
    Button,
    Delete,
    Icon,
    Modal,
    ModalBackground,
    ModalCard,
    ModalCardBody,
    ModalCardFooter,
    ModalCardHeader,
    ModalCardTitle
} from "bloomer";
import ErrorMessage from "../../../elements/ErrorMessage";

interface IDeleteConfirmationProps {
    id: number;
    name: string;
    loading: boolean;
    errorMessage: string;
    onDelete: any;
    onCancel: any;
}

class DeleteConfirmation extends React.Component<IDeleteConfirmationProps, {}> {

    public onDelete = (e: any) => {
        e.target.blur();

        if (this.props.loading) {
            return;
        }

        this.props.onDelete(this.props.id);
    };

    public onCancel = () => {
        this.props.onCancel();
    };

    public render() {
        return <Modal isActive={true}>
            <ModalBackground style={{
                opacity: 0.5
            }}/>
            <ModalCard>
                <ModalCardHeader>
                    <ModalCardTitle>Delete API Key</ModalCardTitle>
                    <Delete onClick={this.onCancel}/>
                </ModalCardHeader>
                <ModalCardBody>
                    Are you sure you want to delete API key <b>{this.props.name}</b>{" ?"}
                    {
                        this.props.errorMessage ? <ErrorMessage>{this.props.errorMessage}</ErrorMessage> : <></>
                    }
                </ModalCardBody>
                <ModalCardFooter>
                    {
                        this.props.loading ? <div style={{
                            textAlign: 'center'
                        }}>
                            <span>Loading...</span>
                            <Icon className="fas fa-spinner fa-spin"/>
                        </div> : <React.Fragment>
                            <Button onClick={this.onDelete}>Delete</Button>
                            <Button onClick={this.onCancel}>Cancel</Button>
                        </React.Fragment>
                    }
                </ModalCardFooter>
            </ModalCard>
        </Modal>;
    }
}

export default DeleteConfirmation;


// WEBPACK FOOTER //
// ./src/routes/APIKeys/DeleteConfirmation/index.tsx